<template>
  <div class="card-form">
    <div class="card-form__wrap">
      <header class="card-form__header">
        <logo/>
        <dropdown :invert-color="false" :defaultValue="$t('cardForm.language.short')">
          <b-dropdown-item
              :active="currentLanguage === 'ru'"
              link-class="authentication__dropdown-item_lang"
              @click="setLocale('ru')"
          >
            {{ $t('cardForm.language.russian') }}
          </b-dropdown-item>
          <b-dropdown-item
              :active="currentLanguage==='en'"
              link-class="authentication__dropdown-item_lang"
              @click="setLocale('en')"
          >
            {{ $t('cardForm.language.english')}}
          </b-dropdown-item>
        </dropdown>
      </header>
      <slot/>
    </div>
    <footer class="card-form__footer">
      <div class="card-form__support">
        {{ $t('CP.gotAnyQuestions')}}
        <a :href="`mailto:${basicInfo.supportServiceEmail}`">{{ $t('CP.contactUs')}}</a>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { SET_LANGUAGE } from '@/store/app/types';
import Dropdown from '../Dropdown/Dropdown';
import Logo from '../Logo/Logo';

export default {
  name: 'CardForm',
  components: {
    Dropdown,
    Logo,
  },
  computed: {
    ...mapState({
      currentLanguage: (state) => state.app.currentLanguage,
    }),
    basicInfo() {
      return this.$store.getters.basicInfo;
    },
  },
  methods: {
    setLocale(locale) {
      this.$i18n.locale = locale;
      this.$moment.locale(locale);
      this.$store.dispatch(SET_LANGUAGE, locale);
    },
  },
};
</script>

<style lang="scss">

  .card-form__wrap {
    box-shadow: var(--box-shadow);
    width: 450px;
    border-radius: 8px;
    background: white;
    margin: 20px auto;
  }

  .card-form__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 50px;
    padding: 40px 40px 0 40px;
  }

  .card-form__support {
    margin-top: 60px;
    color: var(--text-seccond-color);

    a {
      text-decoration: underline;
    }
  }

  .dropdown-item_active {
    background: none !important;
    color: var(--text-seccond-color) !important;
  }

  .authentication__dropdown-item_lang,
  .authentication__dropdown-item_lang:hover,
  .authentication__dropdown-item_lang:focus {
    color: var(--text-main-color);
    background: #FFFFFF;
  }

  .authentication__dropdown-item_lang:active,
  .authentication__dropdown-item_lang.active {
    color: var(--text-main-color);
    background: #F3F6FD !important;
  }

  @media screen and (max-width: $breakpoint-sm) {
    .card-form__wrap {
      min-height: 100%;
      max-width: 100%;
      /*max-width: 550px;*/
      box-shadow: none;
      margin: 0 auto;
      padding: 0;
      /*border: 1px solid var(--gray-lighten);*/
      border-radius: 0;
    }
  }
</style>
